// extracted by mini-css-extract-plugin
module.exports = {"verifyButton":"Winner_verifyButton__2tAXA"};